// extracted by mini-css-extract-plugin
export default {"container":"ShippingSelection_container__h7khZ","menu":"ShippingSelection_menu__d5bKw","opacity":"ShippingSelection_opacity__k+pb-"};